'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { ImageFallbackSvg } from './ImageFallbackSvg.js';

const IDENT = 'Image';
const defaultProps = {
    fit: 'contain',
    fallback: /*#__PURE__*/ jsx(ImageFallbackSvg, {})
};

export { IDENT, defaultProps };
//# sourceMappingURL=Image.contract.js.map
